import { t } from "i18next"
import { useContext, useState } from "react"
import EquipmentOrToolsTypesContext from "../../../context/EquipmentOrToolsTypes/EquipmentOrToolsTypesContext";
import { useNavigate } from "react-router-dom";
import { ItemSelectableWithOptions } from '../../ItemSelectable/ItemSelectableWithOptions';
import { DeleteModal } from "../DeleteModal";
import { useEffect } from "react";

export const EquipmentOrToolType = ({ equipmentTypeId, equipmentDescription, equipmentEnabled }) => {

    const { equipmentOrToolsTypesState, deleteEquipmentOrToolType } = useContext(EquipmentOrToolsTypesContext);
    const { sending, alert, error } = equipmentOrToolsTypesState;

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const navigate = useNavigate();

    const optionsOfBuilding = [
        {
            name: t('EDIT'),
            icon: 'edit-black-icon.svg',
            onClick: () => navigate(`/settings/entityManagment/equipmentOrToolsMaganagement/edit/${equipmentTypeId}`),
        },
        {
            name: t('DELETE'),
            icon: 'trash-bin.svg',
            onClick: () => setShowDeleteModal(true),
        },
    ]

    useEffect(() => {
        setShowDeleteModal(false);
    }, [alert, error])

    return (
        <>
            {showDeleteModal && (
                <DeleteModal
                    showModal={showDeleteModal}
                    setShowModal={() => setShowDeleteModal(false)}
                    deleteFunction={() => deleteEquipmentOrToolType(equipmentTypeId)}
                    deleting={sending}
                    areYouSureMessage={equipmentDescription}
                />
            )}
            <ItemSelectableWithOptions
                options={optionsOfBuilding}
                idPopover={`buildingEdit-${equipmentTypeId}`}
            >
                <div>
                    <p className='m-0 param-section-title'>
                        {equipmentDescription}
                    </p>
                    <p className='m-0 mt-1 param-section-subtitle'>
                        {equipmentEnabled ? t('ENABLED') : t('NOT_ENABLED')}
                    </p>
                </div>
            </ItemSelectableWithOptions>
        </>
    )
}
